import { render } from "./HomeChat.vue?vue&type=template&id=ab214c3e&scoped=true"
import script from "./HomeChat.vue?vue&type=script&lang=js"
export * from "./HomeChat.vue?vue&type=script&lang=js"

import "./HomeChat.vue?vue&type=style&index=0&id=ab214c3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab214c3e"]])

export default __exports__